// -----------------------------
// swiper系
// -----------------------------

(function () {
  //swiper
  let fvSlide = new Swiper(".js-fv-slide", {
    navigation: {
      nextEl: ".fv-btn-next",
      prevEl: ".fv-btn-prev",
    },
    autoplay: true,
    loop: true,
    effect: 'fade',
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      769: {
        spaceBetween: 0,
        slidesPerView: 1,
      },
    },
  });
  let capsuleSlide = new Swiper(".js-capsule-slide", {
    navigation: {
      nextEl: ".capsule-btn-next",
      prevEl: ".capsule-btn-prev",
    },
    pagination: {                       //ページネーション（ドット）
        el: '.swiper-pagination',
    },
    autoplay: true,
    loop: true,
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      769: {
        spaceBetween: 0,
        slidesPerView: 1,
      },
    },
  });
  let uvSlide = new Swiper(".js-uv-slide", {
    navigation: {
      nextEl: ".uv-btn-next",
      prevEl: ".uv-btn-prev",
    },
    pagination: {                       //ページネーション（ドット）
        el: '.swiper-pagination',
    },
    autoplay: true,
    loop: true,
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      769: {
        spaceBetween: 30,
        slidesPerView: 1,
      },
    },
  });
  let colorSlide = new Swiper(".js-color-slide", {
    navigation: {
      nextEl: ".color-btn-next",
      prevEl: ".color-btn-prev",
    },
    pagination: {                       //ページネーション（ドット）
        el: '.swiper-pagination',
    },
    autoplay: true,
    loop: true,
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      769: {
        spaceBetween: 30,
        slidesPerView: 1,
      },
    },
  });
})();
